<template>
    <div class="performanceWaybillMapMonitorSearch">
        <el-form :model="searchForm" ref="searchForm" label-width="86px">
            <el-form-item label="物流订单号：" prop="waybillNo">
                <el-input v-model.trim="searchForm.waybillNo" />
            </el-form-item>
            <el-form-item label="运输单号：" prop="taskNo">
                <el-input v-model.trim="searchForm.taskNo" />
            </el-form-item>
            <el-form-item label="客户订单号：" prop="customerOrderNo">
                <el-input v-model.trim="searchForm.customerOrderNo" />
            </el-form-item>
            <el-form-item label="发车单号：" prop="dispatchNo">
                <el-input v-model.trim="searchForm.dispatchNo" />
            </el-form-item>
        </el-form>
        <div class="searchFormFooter">
            <el-button type="primary" plain size="mini" @click="handleSearch"
                >查询</el-button
            >
            <el-button type="primary" plain size="mini" @click="handleResetForm"
                >重置</el-button
            >
        </div>
    </div>
</template>
<script>
export default {
    name: 'performanceWaybillMapMonitorSearch',
    data () {
        return {
            searchForm: {
                customerOrderNo: '', // 客户订单号
                dispatchNo: '', // 发车单号
                taskNo: '', // 运输单号
                waybillNo: '' // 物流订单号
            }
        };
    },
    methods: {
        // 重置表单
        handleResetForm () {
            this.$refs.searchForm.resetFields();
        },
        // 查询
        handleSearch () {
            this.$emit('search', this.searchForm);
        }
    }
};
</script>
<style lang="less">
.performanceWaybillMapMonitorSearch {
    background-color: #fff;
    position: absolute;
    top: 36px;
    left: 0;
    z-index: 9999999;
    width: 100%;
    border-bottom: 1px solid #ddd;
    padding: 10px 50px 10px 10px;
    box-sizing: border-box;
    .el-form {
        .el-form-item {
            margin-bottom: 0;
            .el-input__inner {
                border-radius: 20px;
            }
        }
    }
    .searchFormFooter {
        text-align: right;
        margin-right: -38px;
        margin-top: 5px;
    }
}
</style>